import * as React from "react";

const SvgIcon = ({ onClick, color = "#F26621" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    fillRule="evenodd"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeMiterlimit="1.5"
    clipRule="evenodd"
    viewBox="0 0 488 488"
    height="25"
    width="25"
    style={{ cursor: 'pointer' }}
    onClick={onClick}
  >
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.54"
      d="M241.955 2952.27v39.79c0 8.37 7.602 15.16 16.966 15.16h44.538M508.473 3007.22h44.538c9.364 0 16.966-6.79 16.966-15.16v-39.79M303.459 2714.17h-44.538c-9.364 0-16.966 6.8-16.966 15.16v39.79M569.977 2769.12v-39.79c0-8.36-7.602-15.16-16.966-15.16h-44.538"
      transform="matrix(1.44027 0 0 1.61218 -341.189 -4368.44)"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="14.58"
      d="M631.903 3158.72c26.96-25.27 43.029-52.2 36.9-129.59-4.019-50.75 64.643-47.39 63.968-5.63-.222 13.78 1.546 34.1.008 57.39M728.96 3110.26c-5.381 26.67-16.903 55.07-40.918 80.92"
      transform="matrix(1.36137 0 0 1.41013 -709.836 -4047.048)"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="14.58"
      d="M562.251 3148.39c20.272-19 32.749-27.51 36.079-66.91M598.864 3049.05c.202-9.28-.761-9.71-.465-21.56 1.884-75.19 113.306-91.32 127.315-7.05M727.417 3050.58c1.41 41.1-1.003 98.28-34.375 140.6"
      transform="matrix(1.36137 0 0 1.41013 -658.861 -4053.64)"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="14.58"
      d="M545.47 3120.84c27.713-18.94 19.497-46.74 21.204-97.72 2.604-77.76 84.404-108.94 140.613-80.8M727.714 2956.36c17.124 15.7 29.205 39.24 31.416 71.21 2.124 30.71.473 82.13-8.487 115.41M743.662 3160.98c-2.053 5.91-2.796 7.04-3.892 8.74M534.892 3067.79c-.686-15.78.301-19.02-.045-47.84-.179-14.98 4.699-28.28 9.623-40.35"
      transform="matrix(1.36137 0 0 1.41013 -658.861 -4053.64)"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="14.58"
      d="M562.17 2949.68c65.659-88.8 219.627-59.57 227.986 73.98 1.978 31.6.133 36.28-.606 45.74"
      transform="matrix(1.36137 0 0 1.41013 -658.861 -4053.64)"
    />
    <path
      fill="none"
      stroke={color}
      strokeWidth="14.58"
      d="M700.505 3023.29s-.397 27.63 0 41.44c.864 30.11-4.366 57.9-22.447 85.99M663.822 3169.76a213 213 0 0 1-8.858 9.75"
      transform="matrix(1.36137 0 0 1.41013 -709.836 -4047.048)"
    />
  </svg>
);

export default SvgIcon;
